import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import { trackEvent } from '../middleware/analyticsMiddleware'
import idx from 'idx'
import { getEnv } from 'aria-viewer/utils/environment'

const logEvent = events => {
    const evts = Array.isArray(events) ? events : [events]

    evts.forEach(evt => {
        const eventName = idx(evt, _ => _.eventPayload.event)

        if (eventName) console.log('KinesisEvent: ' + eventName)
    })
}

export const onPreProcess = (events, getState) => {
    if (getEnv('REACT_APP_VERBOSE_ANALYTICS') === 'true') logEvent(events)

    if (!Array.isArray(events)) {
        return processNonInteractionEvent(events)(getState)
    } else {
        return events.map(evt => {
            return processNonInteractionEvent(evt)(getState)
        })
    }
}

const processNonInteractionEvent = event => getState => {
    const kinesisParition = idx(event, _ => _.eventPayload.properties.KINESIS_PARTITION)

    if (kinesisParition == undefined && event.eventType) {
        const interactionData = getInteractionData()(getState)

        return {
            eventType: event.eventType,
            eventPayload: {
                event: event.eventPayload.event,
                properties: {
                    ...interactionData,
                    ...event.eventPayload.properties,
                },
            },
        }
    }

    return event
}

const getInteractionData = () => getState => {
    const {
        loc_name,
        loc_id,
        owner_id,
        stoptitle,
        stopid,
        inst_name,
        userkey,
        sessionId,
        platform,
        tourid,
        type,
        isClientApp,
        appVersion,
        deviceGrade,
        meanFPS,
    } = getTourData()(getState)

    const date = new Date()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const year = date.getFullYear()

    // The Unix epoch (or Unix time or POSIX time or Unix timestamp) is the number of seconds
    // that have elapsed since January 1, 1970 (midnight UTC/GMT)
    const timeStamp = Math.floor(Date.now() / 1000) // current time in seconds
    const timeStampMilliseconds = Date.now() // current time in milliseconds

    const kinesisParition = `year=${year}/month=${month}/day=${day}/`

    return {
        Institution: inst_name,
        Location: loc_name,
        Inst_ID: owner_id,
        Loc_ID: loc_id,
        Exp_Type: type,
        Tour_ID: tourid,
        Stop_ID: stopid,
        Stop: stoptitle,
        Userkey: userkey,
        SessionID: sessionId,
        platform: platform,
        isClientApp,
        UserTimestamp: timeStamp,
        UserTimestampMilli: timeStampMilliseconds,
        KINESIS_PARTITION: kinesisParition,
        AppVersion: appVersion,
        DeviceGrade: deviceGrade,
        MeanFPS: meanFPS,
    }
}

export const trackInteractionEvent = (eventName, additionalProperties = {}) => getState => {
    const eventProperties = {
        ...getInteractionData()(getState),
        ...additionalProperties,
    }

    return trackEvent(eventName, eventProperties)
}
